require('./scheduledTransfersContentTable.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
import classNames from 'classnames';

// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');

// @ components
const ScheduledTransfersContentTableRow = require('../scheduledTransfersContentTableRow/scheduledTransfersContentTableRow');
const { ScheduledTransfersContentTableInfoRow } = require('../scheduledTransfersContentTableInfoRow/scheduledTransfersContentTableInfoRow');

// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();


class ScheduledTransfersContentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expandedRowId: '' };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    buildNextPageButton() {
        const { immAccountScheduledTransfers } = this.props;
        let buttonContent;

        if (immAccountScheduledTransfers.get('nextPage')) {
            buttonContent = (
                <div className="scheduled-transfers-table__more-transfers">
                    <OKButton modifier="link-complementary" onClick={this.handleNextPage}>
                        <FormattedText
                            value="transfersScheduled-moreTransfers"
                            format="uppercase"
                        />
                    </OKButton>
                </div>
            );
        }

        return buttonContent;
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true} className="scheduled-transfers-table__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="scheduled-transfers-table__table-header-cell-line"
                            colSpan={2}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            const expandClass = classNames('scheduled-transfers-table__table-header-cell', { 'scheduled-transfers-table__table-header-cell--expand-button': __CONTACT_CENTER__ });
            const paddingLeftHeaderCc = classNames({ 'left-space': __CONTACT_CENTER__ });

            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true} className={expandClass} />
                        <OKTableCell asHeader={true} className="scheduled-transfers-table__table-header-cell">
                            <FormattedText value="transfersScheduled-startDate" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className={"scheduled-transfers-table__table-header-cell " + paddingLeftHeaderCc}>
                            <FormattedText value="transfersScheduled-endDate" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className={"scheduled-transfers-table__table-header-cell " + paddingLeftHeaderCc}>
                            <FormattedText value="transfersScheduled-periodicDelayed" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className={"scheduled-transfers-table__table-header-cell " + paddingLeftHeaderCc}>
                            <FormattedText value="transfersScheduled-concept" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="scheduled-transfers-table__table-header-cell--amount">
                            <FormattedText value="transfersScheduled-amount" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="scheduled-transfers-table__table-header-cell" />
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    handleNextPage() {
        const { accountId, requestScheduledTransfersNextPage } = this.props;
        requestScheduledTransfersNextPage(accountId);
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: rowId === this.state.expandedRowId ? '' : rowId
        });
    }

    render() {
        const { immAccountScheduledTransfers, immScreen } = this.props;
        const immAccountScheduledTransfersByOrder = immAccountScheduledTransfers.get('byOrder');
        const immAccountScheduledTransfersById = immAccountScheduledTransfers.get('byId');
        const { expandedRowId } = this.state;
        const nextPageButton = this.buildNextPageButton();
        const tableHead = this.buildTableHead();
        const tableColumns = immScreen.get('isMobile') ? 2 : 7;

        return (
            <div className="scheduled-transfers-table">
                <LastMovementsTable
                    groupByDate={true}
                    rowComponent={ScheduledTransfersContentTableRow}
                    immTransactionsByOrder={immAccountScheduledTransfersByOrder}
                    immTransactionsById={immAccountScheduledTransfersById}
                    columnsCount={tableColumns}
                    expandedRowId={expandedRowId}
                    expandedRowComponent={ScheduledTransfersContentTableInfoRow}
                    onRowClick={this.handleRowClick}
                    id="scheduled-transfers-table"
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    {tableHead}
                </LastMovementsTable>
                {nextPageButton}
            </div>
        );
    }
}

ScheduledTransfersContentTable.propTypes = {
    immAccountScheduledTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestScheduledTransfersNextPage: PropTypes.func,
    accountId: PropTypes.string
};

module.exports = ScheduledTransfersContentTable;
